import React from "react";
import { createPortal } from "react-dom";

function SchedulingContextMenuPortal({ children }) {
  return createPortal(
    <div
      style={{
        isolation: "isolate",
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: 99,
      }}
    >
      {children}
    </div>,
    document.body,
  );
}

export default function SchedulingContextMenu({
  isOpen,
  onClose,
  item,
  clickEvent,
  dayNumber,
  openSlideMenu = () => {},
  setActiveBlock = () => {},
  setActiveContent = () => {},
  removeProgram = () => {},
  duplicateProgram = () => {},
}) {
  const [menuPos, setMenuPos] = React.useState({ x: clickEvent?.clientX ?? 0, y: clickEvent?.clientY ?? 0 });
  const menuRef = React.useRef();

  React.useLayoutEffect(() => {
    if (menuRef.current && clickEvent) {
      const menuHeight = Math.round(menuRef.current.getBoundingClientRect().height);
      const menuWidth = Math.round(menuRef.current.getBoundingClientRect().width);
      const windowHeight = document.body.clientHeight;
      const windowWidth = document.body.clientWidth;

      setMenuPos({
        x:
          windowWidth - clickEvent.clientX <= menuWidth
            ? clickEvent.clientX - (menuWidth - (windowWidth - clickEvent.clientX))
            : clickEvent.clientX, // if menu would get cut off, position left of left edge of screen
        y:
          windowHeight - clickEvent.clientY <= menuHeight
            ? clickEvent.clientY - (menuHeight - (windowHeight - clickEvent.clientY))
            : clickEvent.clientY, // if menu would get cut off, position above top edge of screen
      });
    }
  }, [clickEvent]);

  if (!isOpen) {
    return;
  }

  return (
    <ul className="scheduling-context-menu" style={{ top: `${menuPos.y}px`, left: `${menuPos.x}px` }} ref={menuRef}>
      {item.type === "template_block" ? (
        <li>
          <button
            className="btn"
            onClick={() => {
              setActiveBlock(dayNumber, item.segments, item);
              onClose();
            }}
          >
            Edit Block
          </button>
        </li>
      ) : (
        <li>
          <button
            className="btn"
            onClick={() => {
              setActiveContent(item);
              onClose();
            }}
          >
            View Program
          </button>
        </li>
      )}
      <li>
        <button
          className="btn"
          onClick={() => {
            duplicateProgram(item, dayNumber, false);
            onClose();
          }}
        >
          Copy to each day
        </button>
      </li>
      <li>
        <button
          className="btn"
          onClick={() => {
            duplicateProgram(item, dayNumber, true);
            onClose();
          }}
        >
          Copy to each following day
        </button>
      </li>
      {["series"].includes(item.type) ? (
        <li>
          <button
            className="btn"
            onClick={() => {
              openSlideMenu("repeat", item, "Repeat Scheduling");
              onClose();
            }}
          >
            Repeat Settings
          </button>
        </li>
      ) : null}
      <li>
        <button
          className="btn"
          onClick={() => {
            removeProgram(dayNumber, item);
            onClose();
          }}
        >
          Remove Program
        </button>
      </li>

      <SchedulingContextMenuPortal>
        <div
          onClick={onClose}
          onContextMenu={(e) => {
            e.preventDefault();
            onClose();
          }}
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "transparent",
          }}
        ></div>
      </SchedulingContextMenuPortal>
    </ul>
  );
}
